import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { HiCheck, HiHome } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';
import { COMPANY_INFO } from '../utils/constants';

const ThankYou = () => {
  return (
    <>
      <Helmet>
        <title>Thank You | Rishant Technologies</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <main style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F5F0E8',
        padding: '2rem 1.5rem',
      }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          style={{ maxWidth: '560px', width: '100%', textAlign: 'center' }}
        >
          <div style={{
            background: '#FFFFFF',
            border: '1px solid var(--color-border)',
            borderRadius: '20px',
            padding: 'clamp(2rem, 4vw, 3rem)',
          }}>
            {/* Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 200, damping: 15 }}
              style={{
                width: '4rem', height: '4rem', borderRadius: '50%',
                backgroundColor: '#1A1A1A', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 1.5rem',
              }}
            >
              <HiCheck size={28} color="#FFFFFF" />
            </motion.div>

            <h1 style={{
              fontSize: '2rem', fontWeight: 700, color: '#1A1A1A',
              marginBottom: '0.75rem', fontFamily: '"DM Sans", sans-serif',
              letterSpacing: '-0.02em',
            }}>
              Thank you!
            </h1>

            <p style={{
              fontSize: '1.05rem', lineHeight: 1.65, color: '#666666',
              marginBottom: '2rem', fontFamily: '"DM Sans", sans-serif',
            }}>
              We've received your message and will get back to you within{' '}
              <strong style={{ color: '#1A1A1A' }}>4 business hours</strong>.
            </p>

            {/* Next steps */}
            <div style={{
              background: '#FAF7F2', border: '1px solid var(--color-border)',
              borderRadius: '12px', padding: '1.25rem', marginBottom: '2rem',
              textAlign: 'left',
            }}>
              <h2 style={{
                fontSize: '0.8rem', fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: '0.08em', color: '#999999', marginBottom: '1rem',
                fontFamily: '"DM Sans", sans-serif',
              }}>
                What happens next
              </h2>
              {[
                "We'll review your automation requirements",
                "Our team will prepare a custom proposal",
                "We'll schedule your free 20-minute audit call",
                "You'll see exactly what we can automate",
              ].map((step, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'flex-start', gap: '0.75rem',
                  marginBottom: i < 3 ? '0.75rem' : 0,
                }}>
                  <span style={{
                    flexShrink: 0, width: '1.25rem', height: '1.25rem',
                    borderRadius: '50%', backgroundColor: '#1A1A1A', color: '#FFFFFF',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.65rem', fontWeight: 700, marginTop: '2px',
                    fontFamily: '"DM Sans", sans-serif',
                  }}>
                    {i + 1}
                  </span>
                  <span style={{ fontSize: '0.9rem', color: '#333333', fontFamily: '"DM Sans", sans-serif' }}>
                    {step}
                  </span>
                </div>
              ))}
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <a
                href={COMPANY_INFO.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '14px', backgroundColor: '#1A1A1A', color: '#FFFFFF',
                  borderRadius: '999px', fontSize: '0.95rem', fontWeight: 600,
                  textDecoration: 'none', fontFamily: '"DM Sans", sans-serif',
                }}
              >
                <FaWhatsapp size={18} /> WhatsApp Us
              </a>

              <Link
                to="/"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                  padding: '14px', backgroundColor: 'transparent',
                  border: '1.5px solid var(--color-border)', color: '#1A1A1A',
                  borderRadius: '999px', fontSize: '0.95rem', fontWeight: 600,
                  textDecoration: 'none', fontFamily: '"DM Sans", sans-serif',
                }}
              >
                <HiHome size={18} /> Return to Homepage
              </Link>
            </div>
          </div>

          <p style={{
            marginTop: '1.5rem', fontSize: '0.8rem', color: '#999999',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            Keep an eye on your WhatsApp for a quick follow-up!
          </p>
        </motion.div>
      </main>
    </>
  );
};

export default ThankYou;
